export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    columns: {
      type: String,
      default: null,
    },
    feedback: {
      type: Boolean,
      default: false,
    },
    apply: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasAction() {
      return !!this.$slots.action;
    },
    legendHasContent() {
      return this.title || this.subtitle || this.hasAction || this.feedback;
    },
  },
};
